import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-facebook",
  "use": "various-facebook-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"various-facebook\"><path d=\"M25.295 19.916H21.83v12.35h-5.133v-12.35h-2.44v-4.361h2.44v-2.826c0-2.022.96-5.179 5.18-5.179l3.802.015V11.8h-2.761c-.45 0-1.088.225-1.088 1.187v2.568h3.914l-.45 4.36zM20 0C8.955 0 0 8.956 0 20c0 11.045 8.955 19.998 20 19.998 11.046 0 20-8.953 20-19.998C40 8.956 31.046 0 20 0z\" fill=\"#e3000f\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol